export default "# Number 数字输入\r\n\r\n数字输入控件。\r\n\r\n仅允许输入标准的数字值，可定义范围\r\n\r\n## 何时使用\r\n\r\n- ....。";